import PropTypes from "prop-types"
import React from "react"

import { Context } from "../utility/context"

const ChangeEdition = ({ type }) => (
  <div className="lg-flex flex-end">
    <Context.Consumer>
      {context => (
        <select
          className="edition-select thin fg-mercer-blue-mid"
          value={context.selected[type].edition}
          onChange={event => context.changeEdition[type](event.target.value)}
        >
          <option value="" disabled>
            Change Edition
          </option>
          {context.editions[type].map(edition => (
            <option key={edition} value={edition}>
              {edition}
            </option>
          ))}
        </select>
      )}
    </Context.Consumer>
  </div>
)

ChangeEdition.propTypes = {
  editions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
    })
  ),
}

ChangeEdition.defaultProps = {
  editions: [
    {
      id: `1`,
      label: `Edition 1`,
    },
    {
      id: `2`,
      label: `Edition 2`,
    },
    {
      id: `3`,
      label: `Edition 3`,
    },
  ],
}

export default ChangeEdition
